import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  input,
  Output,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Installer, UsersService } from '@ubie/core';
import { FeedbackService, FormHelper } from '@ubie/shared';

@Component({
  selector: 'acl-account-details',
  standalone: false,
  templateUrl: './account-details.component.html',
  styleUrl: './account-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountDetailsComponent {
  private readonly formBuilder = inject(FormBuilder);
  private readonly userService = inject(UsersService);
  private readonly feedbackService = inject(FeedbackService);

  readonly slideNo = input<number>(0);
  @Output() readonly slideTo = new EventEmitter();
  installer: Installer | undefined;

  contactDetailsForm: FormGroup;

  // FORM VALIDATION VARS
  // ****************************
  // helper for validation
  formHelper: FormHelper;
  // wether submit button was clicked
  readonly isFormSubmitAttempted = signal(false);
  readonly apiError = signal<string | null>(null);

  constructor() {
    this.contactDetailsForm = this.formBuilder.group({
      email: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
    });

    // init form helper for validation
    this.formHelper = new FormHelper(this.contactDetailsForm);
  }

  /**
   * Slide to another slide
   */
  slide(slideNr: number): void {
    this.slideTo.emit(slideNr);
  }

  /**
   * Submit new user form
   */
  submitNewUser(): void {
    this.isFormSubmitAttempted.set(true);
    this.apiError.set(null);
    if (this.contactDetailsForm.valid) {
      const obj = {
        ...this.installer,
        ...this.contactDetailsForm.value,
      };

      this.userService.canRegisterInstaller(obj).subscribe({
        next: () => {
          this.slideTo.emit({ slideNo: this.slideNo(), user: obj });
        },
        error: (error) => {
          const msg =
            'type' in error && error.type === 'badRequestError'
              ? error.message
              : 'general_error';
          this.apiError.set(msg);
        },
      });
    }
  }

  /**
   * go back to slides
   */
  goBack(): void {
    this.slideTo.emit({ slideNo: 0, user: '' });
  }
}
